import { render, staticRenderFns } from "./web-radio.vue?vue&type=template&id=052971da&scoped=true&"
import script from "./web-radio.vue?vue&type=script&lang=js&"
export * from "./web-radio.vue?vue&type=script&lang=js&"
import style0 from "./web-radio.vue?vue&type=style&index=0&id=052971da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052971da",
  null
  
)

export default component.exports